<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content">
    <van-form @submit="submitJsy">
      <van-cell-group inset>
        <div class="upload-jsz-front">
          <h2 class="jsz-titile input-title-hq red-required">本人驾驶证正页</h2>
          <div class="upload-jsz-front-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_image" :before-read="beforeRead" :after-read="uploadJszFront" :before-delete="deleteJszFront"></van-uploader>
          </div>

          <h2 class="jsz-titile input-title-hq red-required">本人驾驶证副页</h2>
          <div class="upload-jsz-front-box last-bottom">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_fy_image" :before-read="beforeRead" :after-read="uploadJszFy" :before-delete="deleteJszFy"></van-uploader>
          </div>

          <div class="jsz-front-info-box">
            <van-field v-model="jsz_name" name="jsz_name" input-align="right" required :value="jsz_name" :rules="[{ validator:validatorJszName, message: '请填写姓名' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">姓名</span>
              </template>
            </van-field>
            <van-field v-model="zjcx" name="zjcx" input-align="right" required :value="zjcx" :rules="[{ validator:validatorZjcx, message: '请填写准驾车型' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">准驾车型</span>
              </template>
            </van-field>
            <van-field v-model="jsz_no" name="jsz_no" input-align="right" required :value="jsz_no" :rules="[{ validator:validatorJszNo, message: '请填写身份证' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">身份证</span>
              </template>
            </van-field>
            <van-field v-model="telephone" name="telephone" input-align="right" required type="tel" :value="telephone" :rules="[{ validator:validatorJszTel, message: '请填写联系电话' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">联系电话</span>
              </template>
            </van-field>
            <ChoseTime :timeVmodel="jszYxq" :timeName="jszYxq" :timeLabel="jszYxqLabel" @getYxq="getJszYxq" :timeValue="jsz_yx_time" />
          </div>
        </div>
      </van-cell-group>

      <div class="cyzgz">
        <van-cell-group inset>
          <div class="upload-cyzgz-front">
            <h2 class="jsz-titile input-title-hq red-required">从业资格证</h2>
            <div class="upload-cyzgz-front-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_image" :before-read="beforeRead" :after-read="uploadCyzgzFront" :before-delete="deleteCyzgzFront"></van-uploader>
            </div>

            <!-- 
            <h2 class="jsz-titile input-title-hq">从业资格证反面</h2>
            <div class="upload-cyzgz-front-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_fm_image" :before-read="beforeRead" :after-read="uploadCyzgzFm" :before-delete="deleteCyzgzFm"></van-uploader>
            </div>
            -->
            <div class="jsz-cyzgz-info-box">
              <ChoseTime :timeVmodel="cyzgYxq" :timeName="cyzgYxq" :timeLabel="cyzgYxqLabel" @getYxq="getCyzgYxq" :timeValue="cyzgz_yx_time" />
            </div>
            
          </div>
        </van-cell-group>
      </div>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn">
          保存
        </van-button>
      </div>

    </van-form>
  </div>
</div>
</template>

<script>
import api from "@/fetch/api"
import Nav from "../Public/navTpl.vue"
import {
  Toast,
  Dialog
} from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import Compressor from 'compressorjs';
export default {
  components: {
    Nav,
    ChoseTime
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      jsz_zm: '',
      cyzgz_zm: '',
      zjcx: '',
      jsz_image: [],
      cyzgz_image: [],
      jsz_fy_image: [],
      cyzgz_fm_image: [],
      jsz_name: "",
      jsz_no: "",
      telephone: "",
      jsz_yx_time: "",
      loadingBtn: false,
      jsz_url: "",
      jsz_fy_url: "",
      cyzgz_url: "",
      cyzgz_fm_url: "",
      cyzgz_yx_time: "",
      jszYxq: "jsz_yx_time",
      jszYxqLabel: "驾驶证截至日期",
      cyzgYxq: "cyzgz_yx_time",
      cyzgYxqLabel: "从业资格证截止日期",
    };
  },
  created() {
    //
  },
  methods: {
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }

      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    validatorJszName(val) {
      if (!val) {
        Toast.fail('请填写姓名');
        return false;
      }
      return val;
    },
    validatorZjcx(val) {
      if (!val) {
        Toast.fail('请填写准驾车型');
        return false;
      }
      return val;
    },
    validatorJszNo(val) {
      if (!val) {
        Toast.fail('请填写身份证');
        return false;
      }
      return val;
    },
    validatorJszTel(val) {
      if (!val) {
        Toast.fail('请填写联系电话');
        return false;
      }
      return val;
    },
    isCardNo(card) {
      //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{17}(\d|X|x)$)/;
      if (reg.test(card) === false) {
        return false;
      }
      return true;
    },
    //提交表单
    submitJsy(values) {

      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var jiashizhengurl = that.jsz_url ? that.jsz_url : "";
      var jieshizhengfburl = that.jsz_fy_url ? that.jsz_fy_url : "";
      var congyezigeurl = that.cyzgz_url ? that.cyzgz_url : "";
      var congyezigefmurl = that.cyzgz_fm_url ? that.cyzgz_fm_url : "";
      if (!jiashizhengurl) {
        Toast.fail('请上传驾驶证正页');
        return false;
      }
      if (!jieshizhengfburl) {
        Toast.fail('请上传驾驶证副页');
        return false;
      }
      if (!congyezigeurl) {
        Toast.fail('请上传从业资格证');
        return false;
      }

      var shenfenzheng = values.jsz_no ? values.jsz_no : "";
      if(!this.isCardNo(shenfenzheng))
      {
        Toast.fail('身份证号码格式不正确');
        return false;
      }

      that.$data.loadingBtn = true;
      var formData = JSON.stringify({
        congyezigeurl: congyezigeurl,
        congyezigefmurl: congyezigefmurl,
        congyezigeyxq: that.cyzgz_yx_time ? that.cyzgz_yx_time : "",
        jiashizhengurl: jiashizhengurl,
        jieshizhengfburl: jieshizhengfburl,
        jiashizhengyxq: that.jsz_yx_time ? that.jsz_yx_time : "",
        name: values.jsz_name ? values.jsz_name : "",
        openid: openid,
        shenfenzheng: shenfenzheng,
        telphone: values.telephone ? values.telephone : "",
        zjcx: values.zjcx ? values.zjcx : "",
      });

      api.beianJsz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'driver'
            })
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    getJszYxq(xszYxq) {
      this.$data.jsz_yx_time = xszYxq
    },
    getCyzgYxq(xszYxq) {
      this.$data.cyzgz_yx_time = xszYxq
    },
    //上传驾驶证正页
    uploadJszFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_image = imageData.jiashizhengurl ? [{
            url: weburl + '/' + imageData.jiashizhengurl
          }] : that.$data.jsz_image;
          that.$data.jsz_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : that.$data.jsz_url;
          that.$data.jsz_name = imageData.name ? imageData.name : that.$data.jsz_name;
          that.$data.jsz_no = imageData.shenfenzheng ? imageData.shenfenzheng : that.$data.jsz_no;
          that.$data.telephone = imageData.telephone ? imageData.telephone : that.$data.telephone;
          that.$data.jsz_yx_time = imageData.jiashizhengyxq ? imageData.jiashizhengyxq : that.$data.jsz_yx_time;
          that.$data.zjcx = imageData.zjcx ? imageData.zjcx : that.$data.zjcx;
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    //上传驾驶证副页
    uploadJszFy(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_fy_image = imageData.jiashizhengurl ? [{
            url: weburl + '/' + imageData.jiashizhengurl
          }] : [];
          that.$data.jsz_fy_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传从业资格证
    uploadCyzgzFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.cyzgz_image = imageData.congyezigeurl ? [{
            url: weburl + '/' + imageData.congyezigeurl
          }] : [];
          that.$data.cyzgz_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    //从业资格证反页
    uploadCyzgzFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgzFm(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.cyzgz_fm_image = imageData.congyezigefmurl ? [{
            url: weburl + '/' + imageData.congyezigefmurl
          }] : [];
          that.$data.cyzgz_fm_url = imageData.congyezigefmurl ? imageData.congyezigefmurl : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteJszFront() {
      this.$data.jsz_image = [];
      this.$data.jsz_url = "";
    },
    deleteJszFy() {
      this.$data.jsz_fy_image = [];
      this.$data.jsz_fy_url = "";
    },
    deleteCyzgzFront() {
      this.$data.cyzgz_image = [];
      this.$data.cyzgz_url = "";
    },
    deleteCyzgzFm() {
      this.$data.cyzgz_fm_image = [];
      this.$data.cyzgz_fm_url = "";
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin-top: 4.75rem;
}
.upload-jsz-front {
    //border-top: 1px solid #ececec;
    padding-top: 0.625rem;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
    }
    .upload-jsz-front-box {
        margin-left: 1rem;
    }
    .last-bottom {
        margin-bottom: 0.625rem;
    }
}

.jsz-front-info-box {
    border-top: 1px solid #ececec;
}
.cyzgz {
    margin-top: 1rem;
}
.upload-cyzgz-front {
    margin-top: 0.625rem;
    //border-top: 1px solid #ececec;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
    }
    .upload-cyzgz-front-box {
        margin-left: 1rem;
    }
}
</style>
